/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * CloudIcon
 */
export default class CloudIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18.24 9h-.576a8.89 8.89 0 00-3.84-4.8C11.904 3 9.6 2.7 7.392 3.3 2.784 4.7 0 9.5 1.152 14.2c.96 4 4.416 6.8 8.448 6.8h8.64c3.264 0 5.76-2.6 5.76-6s-2.496-6-5.76-6zm0 10H9.6c-3.072 0-5.76-2.2-6.528-5.2-.864-3.7 1.248-7.4 4.896-8.5A5.24 5.24 0 019.696 5c1.152 0 2.208.3 3.264.9 1.536.9 2.688 2.5 3.168 4.3.096.4.48.8.96.8h1.152c2.112 0 3.84 1.8 3.84 4s-1.728 4-3.84 4z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

